module.exports={
  "_from": "jsonfeed-to-atom@^1.1.3",
  "_id": "jsonfeed-to-atom@1.1.3",
  "_inBundle": false,
  "_integrity": "sha512-cjEdDXkPwtXXyBC4y74G201e8UUU/nIteOR16J5ymbgfBF3MOhusDJQFAB6QE3ZRfRmFfzi1Wy3oYfqaRAQSRA==",
  "_location": "/jsonfeed-to-atom",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "jsonfeed-to-atom@^1.1.3",
    "name": "jsonfeed-to-atom",
    "escapedName": "jsonfeed-to-atom",
    "rawSpec": "^1.1.3",
    "saveSpec": null,
    "fetchSpec": "^1.1.3"
  },
  "_requiredBy": [
    "/plated"
  ],
  "_resolved": "https://registry.npmjs.org/jsonfeed-to-atom/-/jsonfeed-to-atom-1.1.3.tgz",
  "_shasum": "42599455773783139ae380732de332f28bf5ff1d",
  "_spec": "jsonfeed-to-atom@^1.1.3",
  "_where": "/home/shi/git/IATIswitcheroo/node_modules/plated",
  "author": {
    "name": "Bret Comnes"
  },
  "bugs": {
    "url": "https://github.com/bcomnes/jsonfeed-to-atom/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "striptags": "^3.1.1",
    "xmlbuilder": "^9.0.7"
  },
  "deprecated": false,
  "description": "Convert a JSON feed to an atom feed",
  "devDependencies": {
    "@tap-format/spec": "^0.2.0",
    "coveralls": "^3.0.0",
    "dependency-check": "^3.1.0",
    "existy": "^1.0.1",
    "npm-run-all": "^4.0.2",
    "nyc": "^11.6.0",
    "snazzy": "^7.1.1",
    "standard": "^10.0.0",
    "tape": "^4.7.0",
    "tape-run": "^3.0.0",
    "temporary-directory": "^1.0.2"
  },
  "homepage": "https://github.com/bcomnes/jsonfeed-to-atom#readme",
  "keywords": [
    "atom",
    "json",
    "jsonfeed",
    "rss",
    "xml"
  ],
  "license": "MIT",
  "main": "index.js",
  "name": "jsonfeed-to-atom",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/bcomnes/jsonfeed-to-atom.git"
  },
  "scripts": {
    "debug": "node --nolazy --inspect-brk=9229 node_modules/.bin/tape 'test.js'",
    "report": "nyc report --reporter=text-lcov | coveralls",
    "test": "run-s test:*",
    "test:deps": "dependency-check package.json --missing --unused --no-dev",
    "test:lint": "standard --verbose | snazzy",
    "test:tape": "nyc --reporter=lcov tape 'test.js' | tap-format-spec",
    "update": "node generate-snapshot.js",
    "version": "run-s update && git add snapshot.xml snapshot.json"
  },
  "version": "1.1.3"
}
